export default "__VITE_ASSET__Bv7Mrs2s__"